import { RoomCapacity } from '@common/components/RoomCapacity';
import { BedsIcon } from '@root/styles/icons';
import React from 'react';
import { StaticRoom } from '../hooks/types';
import { OccupancyInfo, OccupancyWrapper } from './styles';

interface OccupancyProps {
  room: StaticRoom;
}

export const Occupancy: React.FC<OccupancyProps> = ({ room }) => {
  const bedTypes = room.beds.types;
  const { maxAdults, maxChildren, maxOccupancy } = room;

  return (
    <OccupancyWrapper>
      <RoomCapacity maxOccupancy={maxOccupancy} maxAdults={maxAdults} maxChildren={maxChildren} />

      {bedTypes && (
        <OccupancyInfo>
          <BedsIcon />
          {bedTypes.reduce((bedTypesList, bed, index, arr) => {
            bedTypesList += `${bed.quantity} ${bed.name}` + (arr[index + 1] ? ', ' : '');
            return bedTypesList;
          }, '')}
        </OccupancyInfo>
      )}
    </OccupancyWrapper>
  );
};
